export default __webpack_public_path__ + "static/media/empty@3x.6b74e512.png";